/* eslint-disable max-len */
export default {
    controls: {
        profile: 'Perfil',
        next: 'Próximo',
        previous: 'Anterior',
        goback: 'Voltar',
        close: 'Fechar',
    },
    landing: {
        banner: {
            title: 'Os melhores desenhos do Cartoon Network em um só lugar!',
            text:
                'No Cartoon Network App você pode assistir os seus desenhos favoritos como Ben 10, Hora de Aventura, As Meninas Superpoderosas, Ursos Sem Curso, Gumball e muito mais.',
            button: 'Veja mais',
        },
        shows: {
            title: 'Seus shows favoritos em qualquer lugar!',
            text:
                'Assista no seu smartphone, tablet, computador ou TV (com Chromecast e AirPlay).',
        },
        benefits: {
            title: {
                part1: 'Muito mais Cartoon Network',
                part2: 'para você curtir',
            },
            feature1: {
                title: 'Episódios completos',
                text:
                    'Assista a episódios completos de O Incrível Mundo de Gumball, Ben 10 e muito mais!',
            },
            feature2: {
                title: 'Sempre atualizado',
                text:
                    'Perdeu um episódio de Trem Infinito? Acesse os episódios mais recentes!',
            },
            feature3: {
                title: 'Estreias exclusivas',
                text: 'Novos desenhos? Você poderá assistir primeiro aqui!',
            },
        },
        login: 'LOGIN',
        help: 'Preciso de ajuda',
        skip: 'Agora não',
        available: 'Também disponível para download',
    },
    walkthrough: {
        page1: {
            title: 'Quero acessar!',
            text:
                'Acesse o Cartoon Network App através de uma operadora ou parceiro!',
        },
        page2: {
            title: 'Preciso pagar?',
            text:
                'Depende do seu plano contratado com nossos parceiros. Em alguns planos, é grátis. Confira na Central de Ajuda.',
        },
        page3: {
            title: 'Originais Cartoon e muito mais!',
            text:
                'Seus desenhos favoritos num só lugar!Temporadas completas e novos episódios para assistir quando quiser!',
        },
    },
    login: {
        title: 'Não é um adulto? Talvez você precise da ajuda de um...',
        continue: 'CONTINUAR',
        help_title: 'Por favor peça ajuda',
        help_subtitle:
            'Fale com um adulto ou responsável para te ajudar com isso.',
    },
    AAA: {
        title: 'Você tem acesso ao CN App?',
        subtitle: 'Selecione o parceiro ou operadora abaixo',
        failure:
            'Você não tem acesso a esse conteúdo. Em caso de dúvida, contate sua operadora.',
    },
    favorites: {
        title: 'Favoritos',
        shows: 'Shows Favoritos',
        episodes: 'Episódios Favoritos',
        noContent: 'NENHUMA SÉRIE OU EPISÓDIO ADICIONADO AO SEUS FAVORITOS',
        noShowTitle: 'NENHUMA SÉRIE ADICIONADA AOS FAVORITOS',
        noEpisodeTitle: 'NENHUM EPISÓDIO ADICIONADO AOS FAVORITOS',
        description1:
            'Aproveite e adicione alguma série ou episódio favorito. Basta tocar no ',
        description2: ' e eles aparecerão aqui',
    },
    footerV2: {
        description:
            'Bem-vindos ao site oficial do Cartoon Network! Aqui você encontra os melhores desenhos animados, jogos grátis, transmissões ao vivo com episódios completos entre outras novidades todos os dias. Séries como: Ben 10, Os Jovens Titãs em Ação, Scooby Doo, Tom & Jerry, O Mundo de Greg, Looney Tunes, Maçã e Cebola, Irmão do Jorel, O Incrível Mundo de Gumball e mais. \n\n Já com o Cartoonito, pais e crianças pequenas podem conhecer o melhor do conteúdo pré-escolar. Assista a clipes e outras séries de forma segura. Tem algo a nos dizer? Converse conosco tamoai@cartoonnetwork.com',
        downloadApp:
            'Baixe o aplicativo agora e garanta diversão para toda a família!',
        privacyPolicy: 'Política de Privacidade',
        termsOfUse: 'Termos de uso',
        FAQandHelp: 'Perguntas frequentes',
        schedule: 'Horário Cartoon Network',
        scheduleCNito: 'Horário Cartoonito',
        preferencesPanel: 'Painel de Preferências',
        disclaimer:
            'O uso deste site significa que você concorda com os Termos de Uso. TM & © 2023 Cartoon Network. Uma empresa Warner Bros Discovery. Todos os direitos reservados. Cartoon Network App faz parte da Turner Sports and Entertainment Digital Network.',
        cookies: 'Gerir Cookies',
    },
    home: {
        title: 'Home',
        watchNext: 'ASSISTA A SEGUIR',
        recommended: 'RECOMENDADOS',
        mostWatched: 'MAIS ASSISTIDOS',
        comedy: 'COMÉDIA',
        adventure: 'AVENTURA',
        newReleases: 'LANÇAMENTOS',
        metaTitle: 'Cartoon Network App - Assista desenhos e shows exclusivos!',
        metaDescription:
            'O melhor do Cartoon em um só lugar. Assista desenhos como Ben 10, Hora da aventura, Steven Universo, As Meninas Super poderosas e muito mais!',
        games: 'MELHORES GAMES',
    },
    shows: {
        title: 'Séries',
        about: 'SOBRE',
        season: 'TEMPORADA',
        minisodes: 'Minisódios',
        shorts: 'Curtas',
        similar: 'SÉRIES SIMILARES',
        favorited: 'Show adicionado aos favoritos',
        unfavorited: 'Show removido',
    },
    onnow: {
        title: 'Ao vivo',
        previewTitle: 'Cartoon Network TV',
        previewSubtitle:
            'Veja os seus shows e desenhos favoritos da TV! O canal ao vivo, diretamente pelo aplicativo, quando e onde quiser',
        previewCTA: 'Assistir agora',
        geoblockError:
            'Parece que você não está no país correto para assistir a este conteúdo com sua conta',
        seoLiveTitle:
            'Assista ao vivo no Cartoon Network nossos originais digitais',
        seoLiveDescription:
            'Streaming ao vivo do nosso conteúdo original que você só assiste aqui no Cartoon Network. Você vai encontrar episódios de conteúdo original, clipes e curtas dos seus desenhos preferidos, como Gumball, Steven Universo e mais! Chame os amigos e assista de onde estiver.',
    },
    onnowV2: {
        tabTitle: 'Ao vivo',
        title: 'Assista shows ao vivo',
        subtitle:
            'Aproveite o canal ao vivo do Cartoon Network e livestreams exclusivos.',
        subtitleNoTV: 'Aproveite livestreams exclusivos.',
        liveTV: 'TV ao Vivo',
        livestream: 'Livestream',
        liveNow: 'Ao vivo agora',
        liveTVTitle: 'Cartoon Network TV',
        notificationsDisabledTitle:
            'Ligue as notificações para ser avisado de novidades por aqui.',
        notificationsAction: 'Me envie notificações',
        emptyTitle: 'Não há nenhuma transmissão ao vivo no momento',
        emptySubTitle:
            'Volte mais tarde para ver se há alguma transmissão ao vivo está prestes a começar',
        emptySubtitleNoNotification:
            'Ligue as notificações e seja avisado de novidades sobre shows e livestreams!',
        notificationsEnabledTitle: 'Você será avisado de nossas novidades.',
    },
    movies: {
        title: 'Filmes',
    },
    video: {
        upNext: 'A SEGUIR',
        autoplay: 'Autoplay',
        recommended: 'VOCÊ PODE GOSTAR',
        episode: 'Episódio',
        concurrencyError:
            'Você possui muitos aparelhos logados ao mesmo tempo. Por favor, faça logout de um de seus outros aparelhos',
        favorited: 'Episódio adicionado aos favoritos',
        unfavorited: 'Episódio removido',
        titleFormat: 'T{season}:E{episode}',
        findOut: 'Veja mais deste show',
        noContent: 'Nenhum conteúdo disponível',
    },
    killSwitch: {
        updateRequired: {
            title: 'Atualização necessária',
            subtitle:
                'Devido a ajustes de segurança, é necessário utilizar uma versão mais nova do aplicativo',
            cta: 'ATUALIZAR AGORA',
        },
        serviceError: {
            title: 'Isso foi inesperado...',
            subtitle:
                'Ocorreu um erro e estamos trabalhando para arrumar o problema. Estaremos de volta em instantes.',
        },
        updateOptional: {
            title: 'Nova Versão Disponível',
            subtitle:
                'Existe uma nova versão disponível para download. Por favor atualize o app visitando a loja.',
            cta: 'ATUALIZAR AGORA',
            skip: 'Agora não',
        },
    },
    error: {
        title: 'OH OH',
        subtitle: 'Alguma coisa deu errado',
        cta: 'Voltar para o início',
        cnito: {
            title: 'Oops! Algo deu errado',
            subtitle:
                'Por favor, tente novamente mais tarde, estamos tentando corrigi-lo.',
        },
    },
    logout: {
        message: 'Você deseja realmente sair?',
        confirm: 'Sim',
        cancel: 'Cancelar',
    },
    drawer: {
        pushNotifications: 'Notificações',
        logout: 'Sair',
    },
    pushNudge: {
        title: 'Não perca nada',
        subtitle1:
            'Habilite as notificações sobre shows e outros serviços. Clique no ícone ',
        subtitle2: ' para ligar e desligar, caso mude de ideia.',
        disclaimer: 'Confira com um adulto antes, tudo bem?',
        cta: 'HABILITAR NOTIFICAÇÕES',
        skip: 'Agora não',
    },
    mobileData: {
        title: 'Dados móveis',
        subtitle:
            'Cartoon Network pode tocar vídeos por WIFI e dados móveis, mas tocar por dados móveis pode ter um custo para você.',
        disclaimer:
            'Podemos desativar a reprodução de vídeos com seus dados se isso ajudar?',
        switchLabel: 'Ativar reprodução de vídeos com dados',
        modalTitle:
            'Ah não! No momento, você não tem seus dados móveis habilitados',
        modalSubtitle:
            'Para reproduzir vídeos usando seus dados, vá para as configurações e habilite a reprodução de dados',
        modalCTA: 'Configurações',
        modalSkip: 'Vou esperar até ter WIFI',
    },
    notifications: {
        title: 'Notificações',
        text:
            'O Cartoon Network pode mandar notificações sobre os novos lançamentos e serviços para o seu celular! Assim, você não vai perder nenhuma novidade.',
        disclaimer: 'Confira antes com um adulto, tudo bem?',
        switchTitle: 'Enviar notificações',
    },
    lockedContent: {
        homeText: 'FAÇA O LOGIN PARA VER MUITO MAIS CONTEÚDO!',
        showText: 'FAÇA O LOGIN PARA VER MUITO MAIS CONTEÚDO!',
        favoriteText: 'FAÇA O LOGIN PARA VER MUITO MAIS CONTEÚDO!',
        unlockShow: 'DESBLOQUEIE TODOS OS EPISÓDIOS DE {{show_title}}',
        shows: {
            title: 'VEJA MUITO MAIS',
            subtitle:
                'Faça o login para assistir a episódios completos dos seus shows favoritos',
            cta: 'ACESSE AGORA',
        },
        playback: {
            title: 'EPISÓDIOS COMPLETOS',
            subtitle:
                'Faça o login para assistir a episódios completos dos seus shows favoritos',
            cta: 'ACESSE AGORA',
        },
        interstitial: {
            title: 'DESBLOQUEIE MAIS CONTEÚDO',
            subtitle:
                'Faça login através de seu provedor de cabo ou um de nossos parceiros',
            item1: 'Mais shows',
            item2: 'Episódios recentes',
            item3: 'Filmes',
            item4: 'Adicionar Favoritos',
            disclaimer: 'Peça a ajuda de um adulto para fazer isto.',
            cta: 'CONECTE-SE',
            skip: 'Continue Explorando',
        },
        drawer: {
            cta: 'Login',
        },
        bottomSheet: {
            title: 'MAIS CONTEUDO',
            subtitle: 'Com login de parceiro',
        },
    },
    downloadApp: {
        title: 'Baixe o aplicativo.',
        text1:
            'Para uma melhor experiência, recomendados o download do aplicativo.',
        text2:
            'Baixe o aplicativo agora e garanta diversão para toda a família.',
        text3:
            'Por favor, verifique a disponibilidade do serviço com nossos parceiros ou operadora de TV a cabo.',
    },
    unsupported:
        'Ainda não suportamos este navegador. Por favor, acesse do Google Chrome ou Firefox.',
    cast: {
        connectTo: 'Conectar a',
        connectingTo: 'Conectando a',
        connectedTo: 'Conectado a',
        castingTo: 'Transmitindo para ',
        disconnect: 'Desconectar',
    },
    smartBanner: {
        text: 'Use o aplicativo para uma melhor experiência',
        cta: 'ABRIR APP',
    },
    smartBannerV2: {
        text: 'Melhore sua experiência',
        cta: 'Baixe o app',
    },
    pickAndPlace: {
        comingSoon: 'EM BREVE',
        live: 'AO VIVO AGORA',
    },
    playerui: {
        replay: {
            title: 'ASSISTIR NOVAMENTE',
            nextTimer: 'Próximo vídeo começa em ',
        },
        settings: {
            title: 'Configurações',
            qualityTitle: 'Qualidade do vídeo',
            qualities: {
                low: 'Baixa',
                med: 'Média',
                high: 'Alta',
            },
            languageTitle: 'Idioma',
            languages: {
                por: 'Português',
                spa: 'Espanhol',
                eng: 'Inglês',
            },
        },
    },
    games: {
        title: 'Jogos',
        featured: 'Destaques',
        allGames: 'Todos os jogos',
        recents: 'Jogados recentemente',
        playCTA: 'Jogar',
        exitModal: {
            title: 'Sair do jogo?',
            subtitle:
                'Se você sair do jogo agora você pode perder seus pontos e seu progresso',
            keepPlaying: 'Continuar jogando',
            exitGame: 'Sair',
        },
        ad: {
            disclaimer: 'Seu jogo irá carregar após este anúncio...',
        },
        metaTitle: 'Jogue com seus personagens favoritos da Cartoon Network!',
        metaDescription:
            'A Cartoon Network tem jogos originais para você, bem aqui! Chame para desafios, encare aventuras e jogue online os melhores com os personagens que você conhece, como Jovens Titãs, Apenas um Show, Copa Toon e mais!',
    },
    ads: {
        unmute: 'Reativar som',
        mute: 'Sem som',
    },
    player: {
        offline: {
            title: 'Oops!',
            message:
                'Por favor verifique sua conexão com a internet e tente novamente.',
            cta: 'Tentar novamente',
        },
    },
    cartoonito: {
        landing: {
            title: 'Cartoonito chegou!',
            message:
                'Cartoon Network apresenta Cartoonito, a nova marca pré-escolar que chega à América Latina, com novos shows exclusivos, franquias globais, produções locais e o melhor conteúdo para as crianças mais novas da família.\nCartoonito é um lugar para cair na gargalhada, expandir seus limites e se divertir com personagens e histórias cativantes.',
            comingSoon: 'EM BREVE!',
            cta: 'PROGRAMAÇÃO',
        },
        programming: {
            title: `PROGRAMAÇÃO`,
            yesterday: 'Ontem',
            today: 'Hoje',
            tomorrow: 'Amanhã',
            yearOfProduction: 'Ano de produção',
            genres: 'Gêneros',
            director: 'Diretor',
            cast: 'Elenco',
        },
        header: {
            cnappCTA: 'Ir para o CN APP',
        },
        cartoons: {
            title: 'Cartoons',
            metaTitle: 'Desenhos e séries do Cartoonito',
            metaDescription:
                'Seus desenhos favoritos, novos lançamentos e curtas de Cartoonito por Cartoon Network',
        },
        games: {
            title: 'Jogos',
            metaTitle:
                'Jogos infantis com seus personagens favoritos do Cartoonito!',
            metaDescription:
                'Uma área de jogos segura e educacional para os pequenos. Jogue com Thomas e seus amigos e Pocoyo!',
        },
        cta: {
            title: 'Uma nova experiência está chegando',
            button: 'Descubra',
        },
        live: {
            title: 'Ao vivo',
        },
        videos: {
            title: 'Vídeos',
            metaTitle:
                'Cartoonito! Desenhos e atividades para crianças pequenas do Cartoon Network',
            metaDescription:
                'Conteúdo pré-escolar com atividades, desenhos e jogos em um ambiente seguro e divertido. Thomas e seus amigos, Pocoyo, Casa Mágica da Gabby e mais!',
        },
    },
    liveCarousel: {
        title: 'Ao Vivo Agora',
        live: 'Ao Vivo',
    },
    onboarding: {
        title: 'ESCOLHER AVATAR',
        done: 'feito',
        skip: 'pular',
    },
    parentalPage: {
        title: 'Para Pais',
        back: 'Voltar para',
        metaTitle: 'Cartoonito para os pais! Atividades para a família!',
        metaDescription:
            'Encontre aqui as melhores atividades pré-escolares dos personagens preferidos dos pequenos, como Mundo Bita para colorir e Casa da Gabby para imprimir.',
        welcome: {
            title: 'Bem vindo',
            subtitle:
                'Há um novo lugar para as crianças em idade pré-escolar. E todo mundo está convidado! Vamos rir, brincar, cantar e nos divertir juntos no Cartoonito. Nossa filosofia enfatiza a curiosidade, empatia, criatividade e coragem em todos os nossos desenhos.',
        },
        overview: {
            title: 'Geral',
            learningActivities: 'Atividades',
            learningActivitiesDescription:
                'Atividades para imprimir que vão ajudar as crianças a aprender, brincar e crescer.',
            learningActivitiesCTA: 'Ver Atividades',
            privacyPolicy: 'Política de privacidade',
        },
        activities: {
            title: 'Atividades',
            disclaimer: 'Mais atividades em breve',
            openCTA: 'Baixar',
            moreLine1: 'Mais',
            moreLine2: 'atividades',
            moreLine3: 'em breve',
        },
        waysToWatch: {
            title: 'Como Assistir',
            subtitle: 'Mais maneiras de assistir e brincar com Cartoonito',
            hboSubtitle: 'Assista agora',
            watchOnTV: 'TV A CABO',
            tvSubtitle: 'Veja a programação',
            cnitoSubtitle: 'Baixe o app em',
            disclaimer:
                'Alguns show disponíveis apenas no canal ou na HBOMax. Confira a disponibilidade.',
        },
        settings: {
            title: 'Configurações',
            subtitle: 'Controle o que as crianças assistem e usam',
            notifications: {
                title: 'Notificações',
                subtitle:
                    'Podemos mandar notificações diretamente no dispositivo para avisar de novos vídeos, jogos ou novidades no aplicativo.',
                text: 'Aceito receber notificações push.',
            },
            mobileData: {
                title: 'Dados Móveis',
                subtitle:
                    'Os vídeos podem ser reproduzidos por Wi-fi ou Dados Móveis. Mas por dados, podem gastar sua franquia.',
                text: 'Habilitar reprodução com dados móveis',
            },
        },
        newsletter: {
            homeTitle: 'Fique por dentro',
            homeSubtitle: 'Inscreva-se para receber novidades e atualizações.',
            homeCTA: 'Inscrever-se',
            homeNew: 'Sou novo!',
            areaTitle: 'Newsletter',
            title: 'As últimas novidades direto no seu e-mail!',
            news: 'Novidades do Cartoonito',
            educational: 'Conteúdo educacional para crianças',
            games: 'Jogos e atividades por e-mail',
            email: 'Email',
            ageCheck: 'Você confirma ter mais de 18 anos.',
            privacyCheck:
                'Você concorda em receber atualizações, notícias, anúncios e ofertas de Cartoonito e de suas afiliadas da WarnerMedia e Discovery e reconhece ter lido a <u>Política de Privacidade.<u>',
            privacyCheckArgentina:
                'Você concorda em receber atualizações, notícias, anúncios e ofertas de Cartoonito e de suas afiliadas da WarnerMedia e reconhece ter lido a <u>Política de Privacidade.<u>',
            cta: 'Subscribe',
            disclaimer:
                'Para parar de receber mensagens ou para saber mais sobre seus direitos, veja as opções disponíveis na <underline>Política de Privacidade</underline> e nos <underline>Termos de Uso</underline>.',
            subscribedConfirmationTitle: 'OBA, VOCÊ ESTÁ INSCRITO!',
            subscribedConfirmationSubtitle:
                'Fique de olho na sua caixa de entrada!',
        },
    },
    comics: {
        title: 'Quadrinhos',
        continueReading: 'Continue a leitura',
        newChapters: 'Novos capítulos',
        allComics: 'Todos os quadrinhos',
        allChapters: 'Todos os capítulos',
        chapter: 'Capítulo',
        about: 'Sobre',
        followTitle: 'Siga para ser notificado de novidades',
        followButton: 'Seguir',
        followingTitle: 'VOCÊ SERÁ NOTIFICADO DE NOVOS CAPÍTULOS',
        followingButton: 'Seguindo',
        moreComics: 'Mais Quadrinhos',
        moreSoon: 'Novos\nquadrinhos\nem breve',
        tutorial1:
            'Arraste para cima para voltar à página principal, compartilhar com amigos ou mudar de capítulo',
        tutorial2: 'Arraste para baixo para mostrar o botão e ir ao topo',
        tutorial3:
            'Use as setas se quiser ir para o capítulo seguinte ou anterior',
        tutorial4: 'Clique aqui se precisar voltar ao início da história',
        tutorialClose: 'Fechar',
        tutorialSkip: 'Pular',
        previous: 'Anterior',
        next: 'Próximo',
        share: 'Compartilhar',
        gotoChapter: 'Vá para o capítulo {chapter}',
        spoiler: {
            title: 'ALERTA DE SPOILER',
            description: 'Último capítulo lido: {chapter}',
            cta: 'Vá para o capítulo {chapter}',
            continue: 'Quero continuar para o capítulo {chapter}',
        },
        read: 'Ler',
        readNow: 'Ler agora',
        chapterRead0: 'Nenhum capítulo lido',
        chapterRead1: '1 capítulo lido',
        chapterRead2: '{count} capítulos lidos',
    },
    search: {
        placeholder: 'Buscar',
        recommended: 'Buscas recomendadas',
        didYouMean: 'Você quis dizer?',
        noResultAlert: 'Ah não!',
        noResultTitle: 'Não conseguimos encontrar o que você está procurando',
        checkLatest: 'Confira nossos vídeos mais recentes!',
        help: 'Busque por uma\nsérie ou jogo',
    },
    push: {
        idleTitle:
            'Siga para ser notificado de novos clipes, jogos e quadrinhos',
        idleSubtitle: 'Peça permissão com seu responsável antes, ok?',
        idleCTA: 'Siga o Cartoon Network',
        followingTitle:
            'Você será notificado de novos clipes, jogos e quadrinhos assim que estiverem por aqui!',
        followingSubtitle:
            'Para desativar as notificações, entre nas configurações do seu navegador.',
        followingCTA: 'Seguindo Cartoon Network',
    },
    dkids: {
        playArea: 'Área de Jogos',
        homeRow: 'Educacional',
        trending: 'Mais jogados',
        footerProgramming: 'Programação',
        copyright:
            'O uso deste site significa que você concorda com os Termos de Uso. TM & © 2023 Discovery Kids. Uma empresa Warner Bros Discovery. Todos os direitos reservados.',
    },
    ageRating: {
        title: 'Classificação de idade',
        subtitle:
            'Escolha uma classificação etária para que possamos filtrar nosso conteúdo para seu filho.',
        age10: '10 anos ou menos',
        age12: '12 anos ou menos',
        all: 'Livre para todas as idades',
        disclaimer:
            'Você pode alterar essa opção a qualquer momento nas configurações.',
        cta: 'Confirmar',
        titleSuccess1: 'Muito',
        titleSuccess2: 'Obrigado',
        subtitleSuccess: 'Seus preferências foram salvas.',
        ctaSuccess: 'Okay',
    },
    stickers: {
        title: 'Baixe o aplicativo',
        latestStickers1: 'ÚLTIMO',
        latestStickers2: 'PACOTE DE STICKERS',
    },
    sponsors: {
        gamesCTA: 'Ir para jogos',
        gameFooter: 'Jogos Cartoon Network',
        advertisement: 'Publicidade',
    },
};
